import { Common } from '../common';

import {
  Document,
  DocumentItem,
  DocumentText,
  FilterOptions,
} from '../models/patient/document';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async get(documentId: string): Promise<Document> {
    const url = this.common.constructPath(`/patient-documents/${documentId}`);
    return this.common.getJSON(url);
  }

  async findAll(options: { patientOrderId: string }): Promise<Document[]> {
    const url = this.common.constructPath(`/patient-documents`, options);
    return this.common.getJSON(url);
  }

  downloadDocument(documentId: string): string {
    return this.common.constructPath(`/patient-documents/${documentId}/file`);
  }

  async getText(documentId: string): Promise<DocumentText> {
    const url = this.common.constructPath(
      `/patient-documents/${documentId}/text`,
    );
    return this.common.getJSON(url);
  }

  async getDocuments(options: FilterOptions): Promise<DocumentItem[]> {
    const url = this.common.constructPath(`/patient-documents/filter`, options);
    return this.common.getJSON(url);
  }
}
